import { PaymentsConfig } from '@weave/schema-gen-ts/dist/schemas/payments-platform/payments-config/payments_config.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPaymentsConfig1Service = bindHTTP(PaymentsConfig);
export const serviceName = 'payments-config1' as const;
